<script>
	import Fab from '../components/Fab.svelte';
	import {
		push
	} from 'svelte-spa-router';
	import {
		fly
	} from 'svelte/transition';
</script>

<div in:fly="{{ y: 50, duration: 200 }}" out:fly="{{ y: -50, duration: 250}}">
	<h2 class="invert">Raft</h2>
	<p class="invert">Beta</p>
	<p class="invert caption">V 0.8.1</p>
</div>
<div class="start-button">
	<Fab on:pressed="{(event) => push(event.detail.ref)}" text=start ref="#/stories" />
</div>

<style>
	div {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	.start-button {
		position: absolute;
		top: 70vh;
		left: calc(50% - 58px);
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
